var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashUatMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlashUATMobile_svg__a",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlashUATMobile_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlashUATMobile_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E74536",
    xlinkHref: "#FlashUATMobile_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlashUATMobile_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.313)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0F1941",
    cx: 25.438,
    cy: 21,
    r: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F5F0",
    cx: 22.438,
    cy: 18.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.063h48v18H0z",
    fill: "#6BA5B4"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Graphik-Regular, Graphik",
    fontSize: 16.5,
    letterSpacing: -0.75,
    fill: "#FFF",
    transform: "translate(0 22.589)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.956,
    y: 13
  }, "UAT")), /*#__PURE__*/React.createElement("path", {
    d: "M28.404 16.469h-2.526l2.838-13.554c.266-1.27-1.446-1.963-2.163-.877l-11.623 17.6c-.516.78.053 1.812.997 1.812h2.01l-3.928 10.62c-.408 1.102 1.033 1.944 1.819 1.062l13.35-14.975c.587-.657.113-1.688-.774-1.688z",
    fill: "#FFB511"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iMmw1MDIwaDdrYSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iMTIiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9IjVsM2VnbG9vcWIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiMybDUwMjBoN2thIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0U3NDUzNiIgeGxpbms6aHJlZj0iIzJsNTAyMGg3a2EiLz4KICAgICAgICA8ZyBtYXNrPSJ1cmwoIzVsM2VnbG9vcWIpIj4KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA0LjMxMykiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjMEYxOTQxIiBjeD0iMjUuNDM4IiBjeT0iMjEiIHI9IjE4LjUiLz4KICAgICAgICAgICAgICAgIDxjaXJjbGUgZmlsbD0iI0Y3RjVGMCIgY3g9IjIyLjQzOCIgY3k9IjE4LjUiIHI9IjE4LjUiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wIDIzLjA2M2g0OHYxOEgweiIgZmlsbD0iIzZCQTVCNCIvPgogICAgICAgICAgICAgICAgPHRleHQgZm9udC1mYW1pbHk9IkdyYXBoaWstUmVndWxhciwgR3JhcGhpayIgZm9udC1zaXplPSIxNi41IiBsZXR0ZXItc3BhY2luZz0iLS43NSIgZmlsbD0iI0ZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyMi41ODkpIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iMTYuOTU2IiB5PSIxMyI+VUFUPC90c3Bhbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvdGV4dD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yOC40MDQgMTYuNDY5aC0yLjUyNmwyLjgzOC0xMy41NTRjLjI2Ni0xLjI3LTEuNDQ2LTEuOTYzLTIuMTYzLS44NzdsLTExLjYyMyAxNy42Yy0uNTE2Ljc4LjA1MyAxLjgxMi45OTcgMS44MTJoMi4wMWwtMy45MjggMTAuNjJjLS40MDggMS4xMDIgMS4wMzMgMS45NDQgMS44MTkgMS4wNjJsMTMuMzUtMTQuOTc1Yy41ODctLjY1Ny4xMTMtMS42ODgtLjc3NC0xLjY4OHoiIGZpbGw9IiNGRkI1MTEiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlashUatMobile as ReactComponent };